import { createModel } from "@rematch/core";
import { RootModel } from ".";

interface State {
  fullScreenModeEnabled: boolean;
}

const initialState: State = {
  fullScreenModeEnabled: false,
};

export const layout = createModel<RootModel>()({
  state: initialState,
  reducers: {
    toggleFullScreenMode(state) {
      return {
        ...state,
        fullScreenModeEnabled: !state.fullScreenModeEnabled,
      };
    },
  },
});
